import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import es from './locales/es.json'

/**
 * El idioma real sale del perfil del usuario (CLAUDE.md §6); `ProtectedRoute`
 * lo sincroniza con `i18n.changeLanguage` en cuanto llega `/auth/me`. Antes
 * de eso (pantalla de login) se usa el valor por defecto del usuario nuevo.
 */
void i18n.use(initReactI18next).init({
  resources: { es: { translation: es }, en: { translation: en } },
  lng: 'es',
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
})

export default i18n
